import React from 'react';
import PropTypes from 'prop-types';
import themeable from 'zignal-landscape/lib/themeable';
import ToolTip from 'zignal-landscape/lib/ToolTip';
import Truncate from 'react-truncate';
import WarningIcon from 'zignal-landscape/lib/Icon/WarningIcon';
import Save2Icon from 'zignal-landscape/lib/Icon/Save2Icon';
import Remove2Icon from 'zignal-landscape/lib/Icon/Remove2Icon';


class Story extends React.Component {

  // TODO: after source checker is merged use it's utilty functions to replace the following
  // two methods
  getClassNameBasedOnCoverage(isValid, isCovered) {
    if (!isValid) {
      return 'invalidStory';
    }
    return isCovered ? 'coveredStory' : 'uncoveredStory';
  }

  getIconBasedOnCoverage(isValid, isCovered) {
    if (!isValid) {
      return WarningIcon;
    }
    return isCovered ? Save2Icon : Remove2Icon;
  }

  getToolTipTextBasedOnCoverage(isValid, isCovered) {
    switch(true) {
      case !isValid:
        return 'Story is invalid';
      case isValid && isCovered:
        return 'Story is covered by at least one dataset';
      case isValid && !isCovered:
        return 'Story is not covered';
      default:
        return null;
    }
  }

  renderProfileList(storyProfiles, profiles) {
    return storyProfiles.map((profile, index) => {
      const profileName = profiles.find((elem) => (elem._id === profile)).name;
      return (
        <span key={profile}>
          <a href="#" onClick={() => this.props.onProfileClick(profile)}>{profileName}</a>
          {storyProfiles.length !== index + 1 && ', '}
        </span>
      );
    });
  }

  renderValidStoryContent() {
    const {
      title,
      campaignName,
      matchingProfiles,
      nonMatchingProfiles,
      body,
      searchType,
      styles,
      profiles
    } = this.props;

    return (
      <div className={styles.storyDetails}>
        {title && (
          <div
            className={`${styles.storyTitle} ${searchType === 'storyText' && title && body ? styles.boldTitle : null}`}
          >
            {title}
          </div>
        )}
        {searchType === 'storyText' && body && <div className={styles.storyBody}>
          <Truncate lines={3} ellipsis="...">{body}{body}</Truncate>
        </div>}
        <ul className={styles.storyCheckerSearchResultList}>
          <li><b>Workspace: </b>{campaignName}</li>
          {matchingProfiles.length > 0 &&
            <li><b>Matches dataset: </b>{this.renderProfileList(matchingProfiles, profiles)}</li>}
          {nonMatchingProfiles.length > 0 &&
            <li><b>Does not match datasets: </b>{this.renderProfileList(nonMatchingProfiles, profiles)}</li>}
        </ul>
      </div>
    );
  }

  renderInvalidStoryContent() {
    const { title, styles } = this.props;
    return (
      <div className={styles.storyDetails}>
        <div>{title}</div>
        <b>Note: </b> Domain or url not valid
      </div>
    );
  }

  render() {
    const {
      styles,
      isCovered,
      isValid,
    } = this.props;

    const Icon = this.getIconBasedOnCoverage(isValid, isCovered);

    return (
      <div className={styles.storyCheckerSearchResult}>
        <div className={styles.storyIcon}>
          <ToolTip position="top" tooltipText={this.getToolTipTextBasedOnCoverage(isValid, isCovered)}>
            <div className={styles[this.getClassNameBasedOnCoverage(isValid, isCovered)]}>
              <Icon />
            </div>
          </ToolTip>
        </div>
        {isValid && this.renderValidStoryContent()}
        {!isValid && this.renderInvalidStoryContent()}
      </div>
    );
  }
}

Story.propTypes = {
  styles: PropTypes.object,
  onProfileClick: PropTypes.func,
  title: PropTypes.string,
  body: PropTypes.string,
  isCovered: PropTypes.bool,
  isValid: PropTypes.bool,
  campaignName: PropTypes.string,
  profiles: PropTypes.array,
  matchingProfiles: PropTypes.arrayOf(PropTypes.string),
  nonMatchingProfiles: PropTypes.arrayOf(PropTypes.string),
  searchType: PropTypes.oneOf(['url', 'storyText']),
};

export default themeable(Story);
